// src/components/Loading.tsx
export default function Loading() {
  return <div style={{ padding: 20 }}>Loading...</div>;
}
